module.exports = __webpack_public_path__ + "static/media/spot15.ecf6e549.webp";